module.exports = __webpack_public_path__ + "static/media/P-2.572e7a1c.jpg";